import './QSFMenuTile.styles.less'
import { useAtom } from 'jotai'
import { themeAtom } from '@/jotai/theme.jotai'
import cx from 'classnames'
import { isDark } from '@/utils/darkmode'
import Fade from '@/components/Fade'

interface Props {
  title: string
  qty?: string
  isActive: boolean
  onPress?: () => void
}

function QSFMenuTile(props: Props) {
  const [theme] = useAtom(themeAtom)

  return (
    <div
      className={`qsf-tile-menu-container ${
        props.isActive
          ? 'active-tile'
          : cx(isDark(theme) && 'dark-inactive-tile', 'inactive-tile')
      }`}
      onClick={props.onPress}
      style={{ cursor: 'pointer' }}
    >
      {props?.qty && (
        <Fade>
          <div className="landing-page-tile-qty">{props.qty}</div>
        </Fade>
      )}
      <div className="landing-page-tile-title">{props.title}</div>
    </div>
  )
}

export default QSFMenuTile
